export const ANSWER_COLOR_PALETTE = [
  {
    primary: '#2E7D32',
    hover: '#1B5E20',
    surface: '#E8F5E9',
    border: '#C8E6C9',
  },
  {
    primary: '#1565C0',
    hover: '#0D47A1',
    surface: '#E3F2FD',
    border: '#BBDEFB',
  },
  {
    primary: '#EF6C00',
    hover: '#E65100',
    surface: '#FFF3E0',
    border: '#FFE0B2',
  },
  {
    primary: '#8E24AA',
    hover: '#6A1B9A',
    surface: '#F3E5F5',
    border: '#E1BEE7',
  },
];

export const BET_ALREADY_MESSAGE = 'このラウンドではすでにベット済みです。';

export const getAnswerColor = (selection) => {
  const selectionIndex = Number(selection);
  const paletteIndex = Number.isInteger(selectionIndex) && selectionIndex >= 0
    ? Math.min(selectionIndex, ANSWER_COLOR_PALETTE.length - 1)
    : 0;

  return ANSWER_COLOR_PALETTE[paletteIndex];
};

export const getBetDisplayLabel = (selection) => {
  const selectionIndex = Number(selection);
  const alphabetIndex = selectionIndex % 26;
  const repeatCount = Math.floor(selectionIndex / 26) + 1;

  return `ベット${String.fromCharCode(65 + alphabetIndex).repeat(repeatCount)}`;
};

export const getBetShortLabel = (selection) => {
  const selectionIndex = Number(selection);
  const alphabetIndex = selectionIndex % 26;
  const repeatCount = Math.floor(selectionIndex / 26) + 1;

  return String.fromCharCode(65 + alphabetIndex).repeat(repeatCount);
};

export const normalizeBetChoices = (choices = []) =>
  (Array.isArray(choices) ? choices : [])
    .filter((choice) => choice !== null && choice !== undefined && String(choice).trim() !== '')
    .slice(0, ANSWER_COLOR_PALETTE.length);

export const buildBetDisplayItems = (choices = []) =>
  normalizeBetChoices(choices).map((choice, index) => ({
    index,
    label: getBetDisplayLabel(index),
    shortLabel: getBetShortLabel(index),
    color: getAnswerColor(index),
    choice,
  }));
